<template>
    <kt-panel>
        <div class="card-body">
            <kt-form-section>
                <kt-form-row>
                    <kt-col xs="12" sm="6" md="6">
                        <kt-form-group>
                            <kt-form-label for="transaction_id">
                                {{ $t('label.server_ip_limitation') }}
                            </kt-form-label>
                            <v-select
                                id="items"
                                name="items"
                                dir="rtl"
                                @input="selectItem"
                                :options="options"
                                class="vSelect  kt-selectpicker"
                                multiple
                                :filterable="false"
                                :getOptionLabel="(item) => item.value"
                            >
                                <template slot="no-options"> آیتم مورد نظر را انتخاب کنید </template>
                                <template slot="option" slot-scope="options">
                                    <div class="d-flex align-items-center">
                                        {{ options.name }}
                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="options">
                                    <div class="selected d-flex align-items-center">
                                        {{ options.name }}
                                    </div>
                                </template>
                            </v-select>
                        </kt-form-group>
                    </kt-col>
                </kt-form-row>
            </kt-form-section>
            <kt-form-section>
                <kt-row>
                    <kt-col xs="12" sm="6" md="6">
                        <button class="btn btn-success btn-wide" @click="action($event, query)">
                            {{ $t('transactions-report.send-request') }}
                        </button>
                    </kt-col>
                </kt-row>
            </kt-form-section>
        </div>
    </kt-panel>
</template>

<script>

export default {
    props: {
        action: {
            default: function (e, query) {
            },
            required: true,
        },
    },
    mounted() {
    },
    methods: {
        clearDate() {
            if (this.query.created_at) {
                this.query.created_at = null
            }
        },
        selectItem(value) {
            this.query = {}
            for (let item in value) {
                this.query[value[item].value] = true
            }
        }
    },
    data() {
        return {
            query: {},
            options: [
                {
                    value: 'server_ip_limitation',
                    name: this.$t('label.server_ip_limitation')
                },
                {
                    value: 'any_payment_limitation',
                    name: this.$t('label.any_limitation_for_payment')
                },
                {
                    value: 'abroad_ips_only',
                    name: this.$t('label.abroad_ips_only')
                },
            ],
        }
    },
}
</script>

<style>

</style>